export default __webpack_public_path__ + "static/media/40227.09d5d663.jpg";